const atIndex = (v, i) => {
  if (Array.isArray(v)) {
    if (typeof i !== "number") return void 0;
    return v[i];
  }
  return v;
};
const getHoverSwatchColor = (pt) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  if (!pt) return null;
  const fd = pt.data;
  const idx = (_a = pt.pointIndex) != null ? _a : pt.pointNumber;
  const markerPoint = (_e = atIndex((_b = fd == null ? void 0 : fd.marker) == null ? void 0 : _b.color, idx)) != null ? _e : atIndex((_d = (_c = fd == null ? void 0 : fd.marker) == null ? void 0 : _c.line) == null ? void 0 : _d.color, idx);
  if (markerPoint) return markerPoint;
  const pieColor = (_i = atIndex((_f = fd == null ? void 0 : fd.marker) == null ? void 0 : _f.colors, idx)) != null ? _i : atIndex((_h = (_g = fd == null ? void 0 : fd.marker) == null ? void 0 : _g.line) == null ? void 0 : _h.color, idx);
  if (pieColor) return pieColor;
  const linePoint = (_k = atIndex((_j = fd == null ? void 0 : fd.line) == null ? void 0 : _j.color, idx)) != null ? _k : fd == null ? void 0 : fd.fillcolor;
  if (linePoint) return linePoint;
  if (!Array.isArray((_l = fd == null ? void 0 : fd.marker) == null ? void 0 : _l.color) && !Array((_m = fd == null ? void 0 : fd.line) == null ? void 0 : _m.color)) {
    return (_p = (_n = fd == null ? void 0 : fd.marker) == null ? void 0 : _n.color) != null ? _p : (_o = fd == null ? void 0 : fd.line) == null ? void 0 : _o.color;
  }
  return void 0;
};
export default getHoverSwatchColor;
